import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue';
import VueMarkdown from 'vue-markdown';
import { useOpenLinkNewTab } from '@/composables';


const __default__ = {
  name: 'CookieDialog',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isCookieDialogShown: {
    type: Boolean,
    required: true,
    default: false,
  },
  popUpTitle: {
    type: String,
    default: '',
  },
  popUpDescription: {
    type: String,
    default: '',
  },
  essentialCookiesTexts: {
    type: Object,
    default: null,
  },
  marketingCookiesTexts: {
    type: Object,
    default: null,
  },
  isEssentialCookiesAccepted: {
    type: Boolean,
    default: false,
  },
  isMarketingCookiesAccepted: {
    type: Boolean,
    default: false,
  },
},
  emits: ['acceptCookieConsent', 'close', 'toggleMarketingCookies', 'toggleAllUnnecessaryCookies'],
  setup(__props, { emit }) {

const props = __props;




const { setTargetAttributeToLink } = useOpenLinkNewTab();

watch(() => props.isCookieDialogShown, () => {
  setTargetAttributeToLink(['description']);
}, { immediate: true });

function onSave() {
  emit('acceptCookieConsent');
  emit('close');
}

return { __sfc: true,props, emit, setTargetAttributeToLink, onSave, VueMarkdown }
}

})